import { Injectable } from '@angular/core';

/**
 * Records which enrollments had a write made against them (lesson completed, rescheduled, attendance
 * taken, survey answered, ...) so a page holding a cached copy of that enrollment knows to reload it,
 * and can keep using its cache otherwise.
 *
 * Lives at the root because the writer and the reader are rarely alive together: the lesson page's
 * state is route-scoped and destroyed on the way back to the enrollment page that needs the answer.
 */
@Injectable({
	providedIn: 'root'
})
export class EnrollmentChangeTrackerService {
	private readonly _changedEnrollmentIDs = new Set<number>();

	markChanged(enrollmentID: number | null | undefined): void {
		if (enrollmentID) {
			this._changedEnrollmentIDs.add(enrollmentID);
		}
	}

	/** True when the enrollment changed since the last call for it; clears the flag either way. */
	consumeChanged(enrollmentID: number): boolean {
		return this._changedEnrollmentIDs.delete(enrollmentID);
	}
}
